import React from 'react'
import { isFunction } from 'lodash'
import { gql } from '@apollo/client'

import { usePaginatedQuery } from 'hooks'
import { QuestionListGroup, QuestionListGroupItem } from '../components'

const QUESTIONS_LIST_QUERY = gql`
  query QuestionList($offset: Int, $max: Int, $filter: QuestionFilter) {
    questionList(offset: $offset, max: $max, filter: $filter) {
      totalCount
      results {
        id
        text
        type
        dimension {
          id
          name
        }
      }
    }
  }
`

export const QuestionDataListGroup = ({
  filter,
  exclude = [],
  actions,
  children,
  placeholder = 'Não há resultados a apresentar',
  ...props
}) => {
  const { data, loading, error } = usePaginatedQuery(QUESTIONS_LIST_QUERY, {
    variables: {
      filter
    }
  })

  const excludedIds = React.useMemo(() => exclude.map(question => question.id), [exclude])
  const excludeFilterFn = question => !excludedIds.includes(question.id)

  return (
    <QuestionListGroup
      {...props}
      placeholder={error ? 'Occoreu um erro' : loading ? 'A carrgar...' : placeholder}>
      {data?.questionList?.results.filter(excludeFilterFn).map((question, index) => (
        <QuestionListGroupItem
          key={index}
          question={question}
          actions={isFunction(actions) ? actions(question) : actions}
        />
      ))}
    </QuestionListGroup>
  )
}

export default QuestionDataListGroup
